export default [
  // 公司相关
  {
    path: '/company/qualify/verify',
    name: 'companyQualifyVerify',
    component: () => import('@/views/company/qualify/verify.vue'),
  },
  {
    path: '/company/qualify/image',
    name: 'companyQualifyImage',
    component: () => import('@/views/company/qualify/image.vue'),
  },
];
